import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, Flow, FlowWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateFlow(): UseMutationResult<
  AxiosResponse<Flow>,
  AxiosError<ErrorMessage>,
  FlowWrite
> {
  const queryClient = useQueryClient();

  const updateFlow = useCallback((flow: FlowWrite): Promise<AxiosResponse<Flow>> => {
    return client.put(`flows/${flow.flowId}/`, flow);
  }, []);

  return useMutation(updateFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('flows');
    },
  });
}
